import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import type { PlaylistsByItem } from '../../api/rootstech/playlist/playlist.types'
import { getPlaylistsByItems as getPlaylistsByItemsApi } from '../../api'

type UsePlaylistsByItems = Omit<UseQueryResult, 'data'> & { playlistsByItems: PlaylistsByItem }

export const usePlaylistsByItems = (ids: string[]): UsePlaylistsByItems => {
  const { data: playlistsByItems = {}, ...rest } = useQuery({
    queryKey: ['playlistsByItems', ids],
    queryFn: async () => getPlaylistsByItemsApi({ ids }),
    staleTime: Infinity,
    select: ({ data }) => data as PlaylistsByItem,
    enabled: ids.length > 0,
  })
  return { playlistsByItems, ...rest }
}
